import { Pagination, createTable, Link as LinkMagik } from "@inmagik/magik-ui"
import { useMemo, useState } from "react"
import { FiltersBase, User } from "../../types"
import dayjs from "dayjs"
import { PAGE_SIZE } from "../../constants"
import { Link } from "react-router-dom"

const Table = createTable<User>()

export function TableUtenti({
  utenti,
  setFilters,
  filters,
  count,
  fullCount,
}: {
  utenti: User[]
  setFilters: (nextFilters: Partial<FiltersBase>) => void
  filters: FiltersBase
  count: number
  fullCount: number
}) {
  // const [sort, setSort] = useState<string>("")
  const [selectedRows, setSelectedRows] = useState<number[]>([])

  const numPages = useMemo(() => {
    if (!utenti) {
      return 1
    }
    return Math.ceil(count / PAGE_SIZE)
  }, [utenti, count])

  return (
    <Table
      data={utenti}
      className="w-100 overflow-scroll flex-1"
      orderBy={filters.ordering.replace("-", "")}
      orderDirection={filters.ordering.startsWith("-") ? "desc" : "asc"}
      onOrderChange={(field, direction) => {
        if (field) {
          if (direction === "desc") {
            setFilters({ ...filters, ordering: `-${field}` })
          } else {
            setFilters({ ...filters, ordering: field })
          }
        } else {
          setFilters({ ...filters, ordering: "" })
        }
      }}
    >
      <Table.HeaderConfig sticky />

      <Table.BodyConfig />

      <Table.Selection
        selectionField="id"
        selectedRows={selectedRows}
        onSelectionChange={(rows) => {
          setSelectedRows(rows)
        }}
      />

      <Table.Column
        title="Nome"
        name="full_name"
        sortable
        width="minmax(max-content, 1fr)"
        render={(user) => (
          <Link to={`/utenti/utenti/${user.id}`}>
            <LinkMagik className="text-dark">{user.full_name}</LinkMagik>
          </Link>
        )}
        stickyLeft
        icon="person"
        // TODO badge
      />
      <Table.Column
        title="Email"
        name="email"
        sortable
        width="minmax(max-content, 1fr)"
        render={(user: User) => user.email}
      />
      <Table.Column
        title="Attivo"
        width="minmax(max-content, 1fr)"
        sortable
        name="is_active"
        render={(user) => (user.is_active ? "Si" : "No")}
      />
      <Table.Column
        title="Permesso elimina"
        width="minmax(max-content, 1fr)"
        sortable
        name="can_delete_data"
        render={(user) => (user.can_delete_data ? "Si" : "No")}
      />

      <Table.Column
        title="Ultimo accesso"
        name="last_login"
        width="minmax(max-content, 1fr)"
        render={(user) => (user.last_login ? dayjs(user.last_login).format("DD/MM/YYYY HH:mm") : "N/A")}
      />
      <Table.Footer.Left>
        Stai visualizzando {count} di {fullCount} utenti
      </Table.Footer.Left>
      <Table.Footer.Center>
        <Pagination page={filters.page} numPages={numPages} onPageChange={(page) => setFilters({ ...filters, page })} />
      </Table.Footer.Center>
    </Table>
  )
}
